import { useState, useEffect, useRef } from "react";
import logo from "../assets/images/gypsycompanion.jpeg";
import { NavLink, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "../assets/css/Navbar.css";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [showTourDropdown, setShowTourDropdown] = useState(false);
  const searchRef = useRef(null);
  const tourDropdownRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const tours = [
    {
      id: 1,
      title: "वाईल्डलाईफ अॅडव्हेंचर - ताडोबा व्याघ्र प्रकल्प",
      subtitle: "Wildlife Safari",
      location: "Tadoba, Maharashtra",
      price: "₹20,000/-",
      duration: "3 Days / 2 Nights",
      category: "gypsy-wildlife"
    },
    {
      id: 2,
      title: "ट्युलिप स्पेशल ऑफबीट काश्मीर टूर",
      subtitle: "Heaven on Earth",
      location: "Kashmir",
      price: "₹20,500/-",
      duration: "5 Days / 4 Nights",
      category: "gypsy-club"
    },
    {
      id: 3,
      title: "मोगली समर कॅम्प",
      subtitle: "Jungle Adventure",
      location: "Bhor, Maharashtra",
      price: "₹8,000/-",
      duration: "3 Days / 2 Nights",
      category: "gypsy-club"
    },
    {
      id: 4,
      title: "पावन चार धाम यात्रा २०२६",
      subtitle: "Char Dham Yatra",
      location: "Uttarakhand",
      price: "₹46,000/-",
      duration: "9 Nights / 10 Days",
      category: "tirthsarthi"
    },
    {
      id: 5,
      title: "सिद्धगिरी कारागीर महोत्सव आणि कणेरी मठ दर्शन",
      subtitle: "Craft Festival & Temple Visit",
      location: "Siddhagiri, Kolhapur",
      price: "₹1,500/-",
      duration: "1 Day",
      category: "tirthsarthi"
    },

    {
      id: 6,
      title: "कैलास मानसरोवर यात्रा",
      subtitle: "🔱 ॐ नमः शिवाय 🔱कैलास मानसरोवर यात्रा २०२६ आत्मसाक्षात्काराचा एक अद्भुत प्रवास!",
      location: "Kathmandu, Kailash, Mansarovar, Tibet",
      price: "₹2,10,000/-",
      duration: "13 Nights / 14 Days",
      category: "tirthsarthi"



    },

    {
  id: 7,
  title: "🌸 Valley of Flowers Trek",
  subtitle: "UNESCO Himalayan Flower Trek",
  location: "Valley of Flowers, Uttarakhand",
  price: "₹16,000/-",
  duration: "6 Days / 5 Nights",
  category: "gypsy-club"
},

{
  id: 8,
  title: "🏔️ Pin Bhaba Pass Trek",
  subtitle: "Ultimate Himalayan Crossover Trek",
  location: "Shimla to Spiti, Himachal Pradesh",
  price: "₹22,500/-",
  duration: "7 Days",
  category: "gypsy-club"
},


  ];

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    if (term.trim() === "") {
      setSearchResults([]);
      setShowResults(false);
    } else {
      const filtered = tours.filter(tour =>
        tour.title.toLowerCase().includes(term.toLowerCase()) ||
        tour.subtitle.toLowerCase().includes(term.toLowerCase()) ||
        tour.location.toLowerCase().includes(term.toLowerCase())
      );
      setSearchResults(filtered);
      setShowResults(true);
    }
  };

  const handleTourClick = (tourId) => {
    setShowResults(false);
    setSearchTerm("");
    setActive(false);
    navigate(`/tourdetails/${tourId}`);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && searchResults.length > 0) {
      handleTourClick(searchResults[0].id);
    }
  };

  const toggleTourDropdown = () => {
    setShowTourDropdown(!showTourDropdown);
  };

  const handleDropdownNavigation = (category, categoryName) => {
    setShowTourDropdown(false);
    setMenuOpen(false);
    navigate(`/tour?category=${category}`, { state: { categoryName, categoryId: category } });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowResults(false);
      }
      if (tourDropdownRef.current && !tourDropdownRef.current.contains(event.target)) {
        setShowTourDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      {/* TOP BAR */}
      <div className="top-bar" style={{ background: "#000", color: "#fff", fontSize: "14px", padding: "10px 0" }}>
        <div className="container d-flex justify-content-between align-items-center">
          <div className="top-left">
            <div className="hide-mobile" style={{ display: "flex", alignItems: "center", background: "linear-gradient(90deg,#1b3a57,#3b5e7c)", paddingRight: "10px", borderRadius: "30px", cursor: "pointer", gap: "10px" }}>
              <div style={{ background: "#1e88e5", width: "32px", height: "32px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff !important", fontSize: "14px" }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </div>
              <span style={{ fontWeight: "600", fontSize: "15px" }}>
                <a href="tel:+919689938912" style={{ fontWeight: "600", fontSize: "15px", color: "#fff", textDecoration: "none" }}>+91 9689938912</a>
              </span>
            </div>

            <div style={{ display: "flex", alignItems: "center", background: "linear-gradient(90deg,#1b3a57,#3b5e7c)", paddingRight: "10px", borderRadius: "30px", cursor: "pointer", gap: "10px" }}>
              <div style={{ background: "#1e88e5", width: "32px", height: "32px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: "16px" }}>✉</div>
              <span style={{ fontWeight: "600", fontSize: "15px" }}>
                <a href="mailto:gypsycompanion@gmail.com" style={{ color: "#fff", textDecoration: "none" }}>gypsycompanion@gmail.com</a>
              </span>
            </div>

            <div className="hide-mobile" ref={searchRef} style={{ position: "relative" }}>
              <div className={`search-bar-container ${active ? "active" : ""}`}>
                <img src="https://cdn4.iconfinder.com/data/icons/evil-icons-user-interface/64/magnifier-256.png" alt="search" className="magnifier" onClick={() => setActive(!active)} style={{ cursor: "pointer" }} />
                <input type="text" className="input" placeholder="Search Tours..." value={searchTerm} onChange={handleSearchChange} onKeyPress={handleKeyPress} onFocus={() => searchTerm.trim() !== "" && setShowResults(true)} />
                <img src="https://cdn1.iconfinder.com/data/icons/google-s-logo/150/Google_Icons-25-256.png" alt="mic" className="mic-icon" style={{ cursor: "pointer" }} />
              </div>

              {showResults && searchResults.length > 0 && (
                <div style={{ position: "absolute", top: "100%", left: 0, right: 0, backgroundColor: "#fff", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", marginTop: "8px", zIndex: 1000, maxHeight: "400px", overflowY: "auto", minWidth: "300px" }}>
                  {searchResults.map((tour) => (
                    <div key={tour.id} onClick={() => handleTourClick(tour.id)} style={{ padding: "12px 16px", borderBottom: "1px solid #e0e0e0", cursor: "pointer", transition: "background-color 0.2s" }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fff"}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ flex: 1 }}>
                          <h4 style={{ margin: 0, fontSize: "14px", fontWeight: "600", color: "#333" }}>{tour.title}</h4>
                          <p style={{ margin: "4px 0 0", fontSize: "12px", color: "#666" }}>📍 {tour.location} | ⏱️ {tour.duration}</p>
                        </div>
                        <span style={{ fontSize: "14px", fontWeight: "bold", color: "#1e88e5", marginLeft: "10px" }}>{tour.price}</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {showResults && searchTerm && searchResults.length === 0 && (
                <div style={{ position: "absolute", top: "100%", left: 0, right: 0, backgroundColor: "#fff", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", marginTop: "8px", padding: "16px", textAlign: "center", zIndex: 1000, minWidth: "250px" }}>
                  <p style={{ margin: 0, color: "#666" }}>🔍 No tours found matching "{searchTerm}"</p>
                  <p style={{ margin: "8px 0 0", fontSize: "12px", color: "#999" }}>Try searching by tour name, location, or type</p>
                </div>
              )}
            </div>
          </div>

          <div>
            <a href="/contact" style={{ background: "#a2f44a", color: "#fff", padding: "6px 16px", borderRadius: "20px", fontWeight: "600", textDecoration: "none", animation: "blink 1s infinite" }}>Book Now</a>
          </div>
        </div>
      </div>

      <header className="site-navbar site-navbar-target">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <div className="site-logo">
              <a href="/">
                <img src={logo} alt="Logo" className="img-fluid" />
              </a>
            </div>
            <button className="mobile-menu-icon" onClick={() => setMenuOpen(!menuOpen)}>☰</button>

            <nav className="site-navigation">
              <ul className={`site-menu main-menu list-unstyled mb-0 ${menuOpen ? "open" : ""}`}>
                <li className="mx-3">
                  <NavLink to="/" className="nav-link" onClick={() => setMenuOpen(false)}>Home</NavLink>
                </li>
                <li className="mx-3">
                  <NavLink to="/about" className="nav-link" onClick={() => setMenuOpen(false)}>About Us</NavLink>
                </li>
                <li className="mx-3" ref={tourDropdownRef} style={{ position: "relative" }}>
                  <div onClick={() => { toggleTourDropdown(); setMenuOpen(true); }} style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "5px", padding: "20px 0", color: "#333", fontWeight: "500", transition: "color 0.3s" }} onMouseEnter={(e) => e.currentTarget.style.color = "#a2f44a"} onMouseLeave={(e) => e.currentTarget.style.color = "#333"}>
                    Trek & Tour
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ transition: "transform 0.3s", transform: showTourDropdown ? "rotate(180deg)" : "rotate(0deg)" }}>
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </div>
                  {showTourDropdown && (
                    <div style={{ position: "absolute", top: "100%", left: 0, backgroundColor: "#fff", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", minWidth: "200px", zIndex: 1000, marginTop: "8px", overflow: "hidden" }}>
                      <div onClick={() => handleDropdownNavigation("tirthsarthi", "तीर्थसारथी")} style={{ padding: "12px 16px", cursor: "pointer", transition: "background-color 0.2s", color: "#333", fontSize: "14px", fontWeight: "500", borderBottom: "1px solid #f0f0f0" }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fff"}>Tirthsarthi</div>
                      <div onClick={() => handleDropdownNavigation("gypsy-club", "Gypsy Club")} style={{ padding: "12px 16px", cursor: "pointer", transition: "background-color 0.2s", color: "#333", fontSize: "14px", fontWeight: "500", borderBottom: "1px solid #f0f0f0" }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fff"}>Gypsy Club</div>
                      <div onClick={() => handleDropdownNavigation("gypsy-wildlife", "Gypsy Wildlife")} style={{ padding: "12px 16px", cursor: "pointer", transition: "background-color 0.2s", color: "#333", fontSize: "14px", fontWeight: "500" }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fff"}>Gypsy Wildlife</div>
                    </div>
                  )}
                </li>
                <li className="mx-3">
                  <NavLink to="/contact" className="nav-link" onClick={() => setMenuOpen(false)}>Contact</NavLink>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
}

export default Navbar;